<template>
	<div>
		<header>
			<div class="w-full flex justify-end items-center gap-2">
				<router-link
					class="btn btn-block btn-fixed-size px-3"
					:to="{ name: 'Home' }"
				>
					<i class="far fa-home mx-2"></i>
				</router-link>
				<button
					v-if="requesters.length > 1 && requester_selected_object"
					class="btn btn-block"
					@click="OpenModal('select-account')"
				>
					<div class="flex items-center justify-center gap-2">
						<i class="far fa-hospital-user"></i>
						<div class="flex flex-col items-start">
							<span class="font-12"> conta selecionada: </span>
							<h4 id="organization-name">
								{{ requester_selected_object.requester.name }}
							</h4>
						</div>
					</div>
				</button>

				<router-link
					class="btn btn-block btn-fixed-size"
					:to="{ name: 'Profile' }"
				>
					<i class="far fa-user mx-2"></i>
				</router-link>
				<button
					class="btn btn-block btn-fixed-size"
					@click="SendToWhatsapp"
				>
					<i class="fab fa-whatsapp mx-2"></i>
				</button>
				<button
					class="btn btn-block btn-fixed-size"
					@click="Logout"
				>
					<i class="far fa-sign-out mx-2"></i>
				</button>
			</div>
		</header>
		<SelectAccount
			:open="modal.select_account"
			@close="modal.select_account = false"
			@change-account="CheckOrganizationStatus"
		>
		</SelectAccount>
	</div>
</template>

<script>
	import { mapGetters, mapActions } from 'vuex'
	import SelectAccount from './modals/SelectAccount'

	const _ = require('lodash')
	export default {
		name: 'Navbar',
		components: {
			SelectAccount,
		},
		props: {
			carousel: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				logo_url: window.logo_url,
				modal: {
					select_account: false,
					carousel: false,
				},
				online_tooltip: '',
			}
		},
		computed: {
			...mapGetters('auth', [
				'requesters',
				'requester_selected_object',
				'online_accounts',
				'recurring_object',
				'requester_selected_id',
				'is_registered',
			]),
			onlines() {
				return this.online_accounts.length >
					this.recurring_object.recurring_accesses
					? this.recurring_object.recurring_accesses
					: this.online_accounts.length
			},
			getEngineOrganization() {
				return parseInt(process.env.VUE_APP_ENGINE_ORGANIZATION_ID)
			},
		},
		watch: {
			requester_selected_object: {
				handler(val) {
					if (this.requesters.length > 1 && !val) {
						this.OpenModal('select-account')
					}
				},
				immediate: true,
			},
		},
		methods: {
			...mapActions('auth', ['Logout', 'GetSubscriptionInfo']),
			...mapActions('system', ['ToggleTheme']),
			SendToWhatsapp() {
				window.open('https://api.whatsapp.com/send?phone=5517981788243')
			},
			OpenModal(modal) {
				this.modal.select_account = false
				this.modal.profile = false

				switch (modal) {
					case 'select-account':
						this.modal.select_account = true
						break
					case 'profile':
						this.modal.profile = true
						break
					case 'carousel':
						this.modal.carousel = true
						break
				}
			},
			CloseCarousel() {
				this.$emit('close-carousel')
			},
			CheckOrganizationStatus() {
				const requester = this.requester_selected_object
				const engine = this.getEngineOrganization

				if (requester) {
					const is_PF =
						requester.account_provider_id ===
						requester.account_requester_id

					if (
						!requester.confirmed &&
						!is_PF &&
						requester.account_provider_id !== parseInt(engine)
					) {
						this.RedirectToOrganizations()

						return
					}

					if (this.$route.name !== 'Home') {
						this.$router.push({ name: 'Home' })
					}
				}
			},
			RedirectToOrganizations() {
				this.$router.push({ name: 'Organizations' })
			},
			ParseNameToTooltip(name) {
				let names = name.toLowerCase().split(' ')

				names = names.map((n, i) => {
					if (n == 'Jr.') return 'Júnior'
					if (i == 0) return n.charAt(0).toUpperCase() + n.slice(1)
					if (n.length == 2) return n
					if (i == names.length - 1)
						return n.charAt(0).toUpperCase() + n.slice(1)

					return n.charAt(0).toUpperCase() + '.'
				})

				return names.join(' ')
			},
			OnlineButtonEffect(effect) {
				const vm = this
				switch (effect) {
					case 'out':
						if (vm.online_tooltip != 'fixed') {
							// vm.ColorIcon(false)
							vm.online_tooltip = ''
						}
						break
					case 'in':
						if (vm.online_tooltip != 'fixed') {
							// vm.ColorIcon(true)
							vm.online_tooltip = 'hover'
						}
						break
					case 'click':
						if (vm.online_tooltip != 'fixed') {
							vm.online_tooltip = 'fixed'
							break
						}
						vm.online_tooltip = ''

						break
					default:
						break
				}
			},
			ColorIcon(state) {
				if (state) {
					document
						.querySelector('.online-icon')
						.classList.remove('text-primary')
				} else {
					document
						.querySelector('.online-icon')
						.classList.add('text-primary')
				}
			},
		},
		mounted() {
			if (this.requester_selected_id && this.is_registered) {
				// this.GetSubscriptionInfo(this.requester_selected_id)
			}
		},
	}
</script>

<style lang="scss" scoped>
	header {
		height: var(--headerHeight);
		background-color: var(--elementsBackgroundColor);
		border-radius: 0.5rem;
		margin: 0 0.5rem;
		padding: 0.375rem 0;

		a.btn,
		.btn {
			&.btn-block {
				padding: 0.5rem 1rem;
				width: fit-content;
				height: 3rem;
				text-overflow: ellipsis;
				outline: none;
				color: var(--navBarButtonsColor);
				background-color: transparent;
				border-radius: 6px;
				display: flex;
				justify-content: center;
				align-items: center;

				&.btn-fixed-size {
					padding: 0.7rem 0.5rem;
					height: 38px;
					width: 42px;
				}

				&:hover {
					color: var(--newPrimaryColor);
					background-color: var(--newPrimaryBackgroundColor);
					border: 1px solid var(--newPrimaryBackgroundColor);
				}

				#organization-name {
					max-width: 250px;
					white-space: nowrap;
					text-overflow: ellipsis;
					overflow: hidden;
					text-transform: uppercase;
					font-size: 14px;
					margin: 0;
				}

				&:hover {
					#organization-name {
						color: var(--white);
					}
				}
			}

			&:hover {
				color: unset;
				background-color: unset;
			}
		}
	}

	.status-indicator {
		margin: 0 0 0 25px;
		font-size: 16px;
		font-weight: 500;
		text-transform: uppercase;
		align-self: center;
	}

	.status-indicator::before {
		content: '';
		border: 1px solid #8e8e8e;
		background-color: #8e8e8e;
		position: absolute;
		top: 6px;
		left: 10px;
		width: 12px;
		height: 12px;
		border-radius: 50%;
	}

	.status-indicator.online::before {
		border-color: #20c964;
		background-color: #20c964;
		box-shadow: 0px 0px 7px 2px #20c964;
	}
</style>
